module.exports = __webpack_public_path__ + "static/media/factory.1009b59a.png";